import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { LineItemRefundStaff } from "./LineItemRefundStaff";
import type { LineItemRefundTaxDTOBase } from "./LineItemRefundTaxDTOBase";
import type { LineItemTaxStaff } from "./LineItemTaxStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class LineItemRefundTaxStaff implements LineItemRefundTaxDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly amountTaxCents: number | null, public readonly amountRefundedCents: number | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly lineItemRefundId: LineItemRefundStaff | null, public readonly taxId: LineItemTaxStaff | null) {
    this.cbiServiceContext = null;
    this.lineItemRefundIdLoaded = this.lineItemRefundId != null;
    this.lineItemRefundIdCached = this.lineItemRefundId;
    this.taxIdLoaded = this.taxId != null;
    this.taxIdCached = this.taxId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private lineItemRefundIdLoaded: boolean;
  private lineItemRefundIdCached: LineItemRefundStaff | null;
  private taxIdLoaded: boolean;
  private taxIdCached: LineItemTaxStaff | null;
  async lineItemRefundIdLazy(): Promise<LineItemRefundStaff | null> {
    if (!this.lineItemRefundIdLoaded) {
      this.lineItemRefundIdCached = await this.cbiServiceContext!.orderService().getLineItemRefundTaxStaffLineItemRefundId(this.assignId);
      this.lineItemRefundIdLoaded = true;
    }
    return this.lineItemRefundIdCached;
  }
  async taxIdLazy(): Promise<LineItemTaxStaff> {
    if (!this.taxIdLoaded) {
      this.taxIdCached = await this.cbiServiceContext!.orderService().getLineItemRefundTaxStaffTaxId(this.assignId);
      this.taxIdLoaded = true;
    }
    return this.taxIdCached!;
  }
}
